<ng-template #attachmentModal>
  <div class="modal-header bg-primary text-white">
    <h4 class="modal-title">Add New Image</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <file-upload formControlName="files" [multiple]="noOfFilesToLimit > 1" [animation]="true"></file-upload>

      <control-wrapper *ngif="showTitle" name="title" label="Image title" [control]="form.controls['title']"
        [validationErrors]="getValidationMessages('title')">
        <input type="text" formControlName="title" class="form-control"
          [class.is-invalid]="isControlInvalid('title')">
      </control-wrapper>

      <control-wrapper *ngIf="showDescription" name="description" label="Description" [control]="form.controls['description']"
        [validationErrors]="getValidationMessages('description')">
        <input type="text" formControlName="description" class="form-control"
          [class.is-invalid]="isControlInvalid('description')">
      </control-wrapper>

      <control-wrapper name="area" label="Image Type" [control]="form.controls['area']">
        <select class="form-control" title="Image Type" formControlName="area">
          <option value="1" selected="selected">Property</option>
          <option value="2">FloorPlan</option>
        </select>
      </control-wrapper>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Cancel</button>
    <!-- <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="form.invalid || isSubmitting"> -->
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]=" isSubmitting">
      <i class="fa fa-upload"></i>
      Upload Image
    </button>
  </div>
</ng-template>

<button class="btn btn-primary" (click)="openModal(attachmentModal)">
  <i class="fa fa-image"></i> Add Image
</button>
